const validationRegex = '(^http(s)*|^webcal)://.+';

export default validationRegex;
